import Breadcrumb from "../../parts/Breadcrumb";
import React from "react";
import labels from "../../constants/Orders";

// For Sales
function View() {
  return <Breadcrumb module={labels.orders} />;
}

export default View;
